// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"MW-z","sponsoredTooltipWrapper":"NW-z","sponsoredTooltip":"OW-z","newCard":"PW-z"};